module.exports = __webpack_public_path__ + "img/car-blue.927ec303.svg";